module.exports = __webpack_public_path__ + "img/level.762fce9a.svg";